import { render, staticRenderFns } from "./ListApplicant.vue?vue&type=template&id=3b5130f0&scoped=true"
import script from "./ListApplicant.vue?vue&type=script&lang=js"
export * from "./ListApplicant.vue?vue&type=script&lang=js"
import style0 from "./ListApplicant.vue?vue&type=style&index=0&id=3b5130f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5130f0",
  null
  
)

export default component.exports